import Vue from 'vue';
import VueRouter from 'vue-router';

import EventBus from '@/utils/EventBus';
import Home from '@/views/Home.vue';
import Login from '@/views/Login.vue';
import Device from '@/views/Device.vue';
import AddDevice from '@/views/AddDevice.vue';
import Locations from '@/views/Locations.vue';
import Geolapse from '@/views/Geolapse.vue';
import Geofence from '@/views/Geofence.vue';
import Content from '@/views/Content.vue';
import Videocalls from '@/views/Videocalls.vue';
import store from '@/store';
import { getUser } from '@/utils/auth';

Vue.use(VueRouter);

let user;
const routes = [
  {
    path: '/',
    component: Home,
    name: 'Home',
    props: true,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/cameras',
    component: Home,
    name: 'Cameras',
    props: true,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/mobiles',
    component: Home,
    name: 'Mobiles',
    props: true,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/headsets',
    component: Home,
    name: 'Headsets',
    props: true,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/login',
    component: Login,
    name: 'Login',
  },
  {
    path: '/device/:id',
    component: Device,
    name: 'Device',
    props: true,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/adddevice',
    component: AddDevice,
    name: 'AddDevice',
    props: true,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/locations',
    component: Locations,
    name: 'Locations',
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/geolapse',
    component: Geolapse,
    name: 'Geolapse',
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/geofence',
    component: Geofence,
    name: 'Geofence',
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/content',
    component: Content,
    name: 'Content',
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/videocalls',
    component: Videocalls,
    name: 'Videocalls',
    meta: {
      requiresAuth: true,
      videocalls: true,
    },
  },
];

const router = new VueRouter({
  routes,
});

EventBus.$on('authState', async (state) => {
  if (state === 'SIGNED_OUT') {
    // Reset user
    user = null;
    // Reset store
    store.commit('user', null);
    // Redirect to login view
    router.replace({ name: 'Login' });
  } else if (state === 'SIGNED_IN') {
    // User clicked sign in successfully
    // Get user attributes
    user = await getUser();

    router.replace({ name: 'Cameras' });
    // router.push({ path: redirectPath });
    // redirectPath = '';
  }
});

router.beforeResolve(async (to, from, next) => {
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    user = await getUser();
    if (!user) {
      // redirectPath = to.path;
      return next({
        name: 'Login',
      });
    }
    if ((to.matched.some((record) => record.meta.videocalls) && user.attributes['custom:videocalls'] !== true)
    || to.name === 'Home') {
      return next({
        name: 'Cameras',
      });
    }
    return next();
  }
  return next();
});

export default router;
